import { useMemo } from "react";
import { ArrowRightIcon } from "../icons/Icons";
import HeroMotion from "./visuals/HeroMotion";
import { hero, meta } from "../content";


export default function Hero({ gradientBg }) {
    const reduceMotion = useMemo(() => (
        typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ), []);

    // A CTA with no href is not yet published — don't render a dead link.
    const ctas = hero.ctas.filter((c) => c.href);

    return (
        <section id="home" className="relative overflow-hidden min-h-[70vh] sm:min-h-[80vh]">
            {/* gradient behind everything */}
            <div className={`absolute inset-0 z-[-2] bg-gradient-to-b ${gradientBg}`} />
            {/* framer-motion background */}
            {!reduceMotion && <HeroMotion />}
            {/* content */}
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 grid md:grid-cols-2 gap-10 items-center">
                <div>
                    <p className="inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-emerald-300/90 bg-white/5 border border-white/10 rounded-full px-3 py-1 mb-4">
                        <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-300" /> {hero.availability}
                    </p>
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight">
                        {hero.greeting} <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-emerald-300">{hero.name}</span>
                        <br /> <span className="font-mono text-3xl sm:text-4xl lg:text-5xl">{hero.headlineTail}</span>
                    </h1>
                    <p className="mt-5 text-slate-300 max-w-prose">{hero.subhead}</p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        {ctas.map((c) => (
                            c.variant === "primary" ? (
                                <a key={c.label} href={c.href} className="inline-flex items-center gap-2 rounded-2xl bg-cyan-400/90 hover:bg-cyan-300 text-slate-900 font-semibold px-5 py-3 transition shadow-lg shadow-cyan-500/10">
                                    {c.label}<ArrowRightIcon className="w-4 h-4" />
                                </a>
                            ) : (
                                <a key={c.label} href={c.href} className="inline-flex items-center gap-2 rounded-2xl border border-white/10 hover:border-emerald-300/60 px-5 py-3 transition">
                                    {c.label}
                                </a>
                            )
                        ))}
                    </div>
                </div>
                <div className="relative">
                    <div className={`relative mx-auto w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 rounded-[3rem] bg-[linear-gradient(to_right,rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.05)_1px,transparent_1px)] [background-size:24px_24px] grid place-items-center overflow-hidden`}>
                        <img src={meta.headshot} alt={`${meta.name}, AI Engineer`} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                </div>
            </div>
        </section>
    );
}
